export default {
    state: {
        editValueRestrictionMenu: {
            isVisible: false
        },
        addValueRestrictionMenu: {
            isVisible: false
        }
    },
    mutations: {
        setEditValueRestrictionMenuVisibility (state) {
            state.editValueRestrictionMenu.isVisible = !state.editValueRestrictionMenu.isVisible
        },
        setAddValueRestrictionMenuVisibility (state) {
            state.addValueRestrictionMenu.isVisible = !state.addValueRestrictionMenu.isVisible
        }
    },
    actions: {
        changeEditValueRestrictionMenuVisibility ({ commit }) {
            commit('setEditValueRestrictionMenuVisibility')
        },
        changeAddValueRestrictionMenuVisibility ({ commit }) {
            commit('setAddValueRestrictionMenuVisibility')
        }
    },
    getters: {
        editValueRestrictionMenu: (state) => state.editValueRestrictionMenu,
        addValueRestrictionMenu: (state) => state.addValueRestrictionMenu
    }
}
